import React from 'react'

import styles from './PromoBanner.module.css'

const PromoBanner = ({ className = '', url, imgSrc }) =>
  <div className={`promoBanner ${styles.promoBanner} ${className}`}>
    <div className={`promoBannerInner ${styles.promoBannerInner}`}>
      {url
        ? <a href={url} target="_blank" rel="noopener noreferrer"><img src={imgSrc} /></a>
        : <img src={imgSrc} />}
    </div>
  </div>

export default PromoBanner
